<template>
  <Admin style="background: #f2f2f2">
    <v-main>
      <v-container fluid>
        <v-card class="rounded-xl tw-min-h-80">
          <v-card-text v-if="!selectedCompany.isDemo" class="tw-p-0">
            <v-breadcrumbs :items="items" class="tw-pt-10 tw-pl-10">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
              <template v-slot:item="{ item }">
                <v-breadcrumbs-item
                  :to="item.to"
                  :disabled="item.disabled"
                  :exact="true"
                >
                  {{ item.text }}
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>
            <v-row class="row-wrapper tw-px-10">
              <v-col>
                <h2
                  class="tw-font-bold tw-text-xl tw-text-black tw-tracking-wide"
                >
                  แก้ไขร้านค้า
                </h2>
              </v-col>
            </v-row>
            <v-row>
              <!-- edit shop form -->
              <div class="tw-max-w-xl tw-mx-auto tw-py-12">
                <shop-form
                  v-if="!loading"
                  ref="shopForm"
                  :companyId="this.companyId"
                  :shopId="shopId"
                  :shop="shop"
                />
              </div>
            </v-row>
          </v-card-text>
          <div
            v-else
            class="align-center justify-center"
            style="height: 200px; display: flex"
          >
            No Permission
          </div>
        </v-card>
      </v-container>
    </v-main>
  </Admin>
</template>

<script>
import Admin from '../../../components/admin/admin-main-template.vue'
import ShopForm from '../../../components/admin/settings/shops/shop-form.vue';
import { mapState } from 'vuex'

export default {
  name: 'ShopEdit',
  components: {
    Admin,
    ShopForm,
  },
  computed: {
    ...mapState({
      selectedCompany: state => state.companies.selectedCompany,
    }),
    items() {
      return [
        {
          text: 'ตั้งค่า',
          disabled: false,
          to: { name: 'Company.Settings' },
        },
        {
          text: 'จัดการใบสั่งขายออนไลน์',
          disabled: false,
          to: { name: 'Company.Settings.Shops', params: { shopId: this.shopId } },
        },
        {
          text: 'แก้ไขร้านค้า',
          disabled: true,
        },
      ]
    }
  },
  data: () => ({
    loading: false,
    companyId: '',
    shopId: '',
    shop: {},
  }),
  async created() {
    this.loading = true
    const companyId = this.$route.params.companyId
    const shopId = this.$route.params.shopId
    this.companyId = companyId
    this.shopId = shopId
    this.shop = await this.$store.dispatch('shops/getData', {
      companyId: this.companyId,
      shopId: this.shopId,
    })
    this.loading = false
  },
}
</script>

<style lang="scss" scoped>
</style>
